export const environment = {
  production: false,
  gatewayUrl: 'https://api.sed-plus-dev.riotinto-dna.com',
  lambdaUrl: 'https://api.sed-plus-dev.riotinto-dna.com',
  cognitoDomain: 'sedplus-dev.auth.ca-central-1.amazoncognito.com',
  cognitoRedirectIn: 'https://sed-plus-dev.riotinto-dna.com/',
  cognitioRedirectOut: 'https://sed-plus-dev.riotinto-dna.com/',
  cognitoUserPoolId: 'ca-central-1_7lmUonXgi',
  cognitoUserPoolWebClientId: '2psv8g3fmeuvfgvlbuj0r5s56p',
  cognitoUrl:
    'https://sedplus-dev.auth.ca-central-1.amazoncognito.com/login?client_id=2psv8g3fmeuvfgvlbuj0r5s56p&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=http%3A%2F%2Flocalhost%3A4200%2F',
  cognitoIdentityPoolId: 'ca-central-1:65acb66d-b17f-4d29-9fe8-b4f3cf8c34c1',
  cognitoAwsRegion: 'ca-central-1',
};
